export default "__VITE_ASSET__BBVvNxGh__"